module.exports = __webpack_public_path__ + "static/media/1_en.af3459c7.png";